var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _vm.$page.props.staffView
            ? _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", sm: "6" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                        Activity Log\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-card-subtitle", { staticClass: "caption" }, [
                            _vm._v(
                              "\n                        Last Online:\n                        " +
                                _vm._s(
                                  _vm.user.last_seen
                                    ? _vm.globalMomentFullDateAtTimeShort(
                                        new Date(_vm.user.last_seen)
                                      )
                                    : null
                                ) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  !_vm.activities
                                    ? _c("v-skeleton-loader", {
                                        staticClass: "mb-6",
                                        attrs: {
                                          type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
                                          boilerplate: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-simple-table", [
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.activities, function (item) {
                                        return _c("tr", { key: item.id }, [
                                          _c("td", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.globalMomentDateAtTimeDots(
                                                    item.created_at
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(item.description)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  item.date
                                                    ? _vm.globalMomentDateAtTimeDots(
                                                        item.date
                                                      )
                                                    : ""
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                        ])
                                      }),
                                      0
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$page.props.staffView
            ? _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", sm: "6" } },
                [
                  _c("ContactHistory", {
                    attrs: {
                      receivedHistory: _vm.receivedHistory,
                      sentHistory: _vm.sentHistory,
                      user: _vm.user,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }